import { Box, Typography, useTheme } from "@mui/material";
import { blueGrey } from "@mui/material/colors";
import { IStepItem } from "..";
import CheckCircle from "../../../../../../../../media/images/icons/check-circle";

export default function StepItem({ title, date, status, index }: IStepItem) {
  const theme = useTheme();

  const color =
    status === "done"
      ? theme.palette.success.main
      : status === "inprogress"
      ? "secondary.main"
      : blueGrey[400];
  return (
    <Box
      sx={{
        // border: "1px solid gray",
        position: "relative",
        display: "flex",
        // flexDirection: "column",
        alignItems: "start",
        // width: "100%",
        gap: "16px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          height: "100%",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "12px",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: "12px",
              height: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // borderRadius: "50%",
              // backgroundColor:
              //   status === 0
              //     ? grey[300]
              //     : status === 1
              //     ? "secondary.main"
              //     : "success.main",
            }}
          >
            {status === "done" ? (
              <CheckCircle color={color} size={18} />
            ) : (
              <Box
                sx={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  backgroundColor: color,
                }}
              ></Box>
            )}
          </Box>
          {index !== 4 && (
            <Box
              sx={{
                width: "2px",
                flex: 1,
                backgroundColor: color,
                height: "100%",
              }}
            ></Box>
          )}
        </Box>
        <Box
          sx={{
            // border: "1px solid gray",
            // position: "absolute",
            top: "-2px",
            minHeight: "80px",
            // width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            noWrap
            sx={{
              fontSize: "12px",
              color: color,
            }}
          >
            <div
              style={{
                whiteSpace: "nowrap",
              }}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </Typography>
          {status === "done" && (
            <Typography
              sx={{
                fontSize: "12px",
              }}
            >
              {date}
            </Typography>
          )}

          {status === "done" && (
            <Typography
              noWrap
              sx={{
                width: "fit-content",
                padding: "4px",
                backgroundColor: "success.light",
                textAlign: "center",
                color: "success.main",
                fontSize: "10px",
                fontWeight: "700",
                borderRadius: "4px",
              }}
            >
              {"انجام شده"}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
